<template>
  <div class="operation_question">
    <div class="question_title">
      <span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
      <span>({{questionData.sectionPrompt+"  本题"+questionData.score+"分。"}})</span>
    </div>
    <div class="title">
      <div v-if="questionData.questionContent" class="ql-editor title_one" v-html="questionData.questionContent"></div>
      <h1 style="overflow: auto;" class="ql-editor" v-html="questionData.questionDto.questionContent"></h1>
    </div>
    <div v-if="isShowLeft" class="start">
      <el-button @click="start(questionData.questionDto)" style="width:120px;" type="primary" round>开始答题</el-button>
    </div>
  </div>
</template>

<script>
		import axios from 'axios';
		import * as api from "../../../../../api/testExamApi";
    import {moduleId} from "../../../../../store/modules/exam";
    import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
    import crypto from 'crypto';
    import qs from 'qs';
    export default {
        name: "operation",
				data(){
					return {
						template: {}
					}
				},
        computed:{
            ...mapState(moduleId, {
                questionData: state => state.questionData,
                paperData: state => state.paperData,
                isShowLeft: state => state.isShowLeft,
								iframeUrl: state => state.iframeUrl,
            }),
        },
        methods:{
            ...mapMutations(moduleId,['SHOW_OPTIONS','SET_IFRAME_URL','GET_SIGN','SHOW_BACK','SHOW_LEFT','SAVE_ANSWER_SUCCESS']),
            start(data){
							console.log(data)
              if(data.eventTemplate === undefined){
                this.$messageError("跳转路径url配置错误！");
                return false;
              }
              $(".content_box").css("flex-direction","row");
              $("#wrapMain").css("height","100%");
              $("#wrapMain").css("width","75%");
              $("#frame").css("width","25%");
               this.SHOW_LEFT(false);
               this.SHOW_OPTIONS(true);
               this.SHOW_BACK(true);
               this.saveTest();
               this.setUrl(data.eventTemplate.eventUrl);
               // this.getSign(itemId);

            },
            getSign(itemId){
            	api.fzUrlExam(this.paperData.saveStuAnswer.examStudentId,itemId,new Date().getTime()).then((result)=>{
                    console.log(result);
                    if(result.code === "0"){
                            this.GET_SIGN(result.data);
                    }else if(result.code === "1"){
                        this.$messageError("接口错误！")
                    }
                });
            },
            saveTest(){
              let obj = {
                "examPaperId":this.paperData.examPaperId,
                "subjectId":localStorage.getItem("subjectId"),
                "classId":this.$route.query.classId,
                "className":this.$route.query.className,
                "courseId":this.$route.query.id,
                "paperCode":this.$route.query.paperCode,
                "paperId":this.$route.query.paperId,
                "questionId":this.questionData.questionId,
                "questionType":9,
                "userAnswer": 1,
                "score":this.questionData.score,
                "questionStatus":0,
                "useTime": 1,
                "version":"1",
                "type":this.$route.query.type
              };
              api.recordExam(obj).then((result)=>{
                if(result.code === "0"){
                  this.SAVE_ANSWER_SUCCESS({
                    status:1,
                    questionId:this.questionData.questionId
                  });
                }
              });
            },
          //把url?后面的参数转换为对象
          getUrlArgs(url,parameter) {
            let obj = {};
            let arr1 = url.split("?");
            let arr2 = arr1[1].split("&");
            for(let i=0 ; i < arr2.length; i++){
              let res = arr2[i].split("=");
              obj[res[0]] = res[1];
            }
            return obj;
          },
          setUrl(url){
            let that = this;
            //sha1加密
            let obj = this.getUrlArgs(url,"?");
            if(obj.platform == 'dummy'){
							let token = localStorage.getItem('Authorization');
							let strUrl = url+`&token=${token}&paperId=${this.$route.query.paperId}&questionId=${this.questionData.questionId}&courseId=${this.$route.query.id}&classId=${this.$route.query.classId}`;
							let obj ={
							  type:"fz",
							  url:strUrl
							};
              that.SET_IFRAME_URL(obj);
            }else{
              let phone = sessionStorage.getItem('mobile');
              let name = sessionStorage.getItem('loginName');
              let schoolId = sessionStorage.getItem('deptId');
              let schoolName = localStorage.getItem('schoolName');
              let time = new Date().getTime() +"";
              let userId = sessionStorage.getItem('userId');
							let professional = sessionStorage.getItem('professional')
              let arr = [
                { key:"classId", value:that.$route.query.classId },
                { key:"courseId", value:that.$route.query.id },
                { key:"className", value:that.$route.query.className},
                { key:"questionId", value:that.questionData.questionId },
                { key:"paperId", value:that.$route.query.paperId },
                { key:"mobile", value:phone },
                { key:"nickName", value:name },
                { key:"schoolId", value:schoolId },
                { key:"schoolName", value:schoolName },
                { key:"time", value:time },
                { key:"userId", value:userId },
                { key:"model", value:"cy" },
              ];
              async function getData(){
                let list = await that.getparams(that.questionData.questionId);
                console.log(list);
                if(list.length > 0) {
                  arr.map((item) => {
                    list.push(item);
                  });

                  function sortNum(prop) {
                    return function (a, b) {
                      let value1 = a[prop];
                      let value2 = b[prop];
                      return value1.localeCompare(value2)
                    }
                  }

                  list.sort(sortNum('key'));
                  let sign = "";
                  list.forEach((item) => {
                    sign += `${item.key}=${item.value}&`
                  });
                  let param = {};
                  list.forEach((item) => {
                    param[item.key] = item.value;
                  });
									console.log(sign)
                  let sha1sign = that.setSha1(sign.substring(0, sign.length - 1));
                  param.sign = sha1sign
									let node_url;//请求地址
									if (obj.platform == 'mgy') {//摩估云
										node_url = process.env.MGYCY_API;
									}else if(obj.platform == 'gzyy'){//估值应用
										node_url = process.env.STX_PG_API;
									}else if(obj.platform == 'middleMGY'){//中级摩估云
											node_url = process.env.mgy_API_ZJ;
									}else if(obj.platform == 'shanglv'){//商旅
											that.slJump(that.questionData, that.questionData.questionId)
									}else{
										node_url = process.env.STXDX_API;
									}
                  axios.post(node_url, qs.stringify(param)).then(res => {
                    if (res.data.result) {
                      //区分仿真，三天下，
                      let obj ={
                        type:"stx",
                        url:res.data.value
                      };
                      that.SET_IFRAME_URL(obj);
                    } else {
                      that.$messageError(res.data.error.message)
                    }
                  }).catch(err => {
                    console.log(err)
                  })
                }
              }
              getData();

            }

          },
          /**
           *
           *根据资源ID 获取动态参数列表
           */

          getparams(questionId){
            let list = [];
            return new Promise((resolve) => {
            	api.getParams(questionId).then(rs => {
                  console.log(rs);
                  if (rs.code === "0") {
                    if (rs.data.length > 0) {
                      rs.data.map((item)=>{
                        let obj={
                          key:item.param,
                          value: item.value
                        }
                        list.push(obj);
                      })
                      resolve(list);
                    }
                    resolve(list);
                  }else{
                    this.$messageError(rs.msg);
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  that.$messageError("后台接口错误！");
                });
            })

          },
          /**
           * 开始跳转三天下
           */
          setSha1(url,secretKey){// 加密
            let hmac = crypto.createHmac('sha1', secretKey || '123456');
            hmac.update(url);
            return hmac.digest('hex');
          },
					slJump(data, id){//商旅跳转
					  let that = this
						console.log(data);
					  that.template = data;
					  async function getData() {
					    let jumpObj = that.getJumpInfo('sl',id)
					    let roleCodes = []
					    let arr = [];
							let index = data.questionDto.eventTemplate.eventUrl.lastIndexOf("=")
							roleCodes.push(data.questionDto.eventTemplate.eventUrl.slice(index+1));
					    roleCodes = roleCodes[0]
					    let templateCode = ''
					    let list = await that.getparams(id);
					    if(list.length>0){
					      list.forEach(v=>{
					        if(v.key == "templateCode"){
					          templateCode = v.value
					        }
					      })
					    }
					    let name = Base64.encode(jumpObj.nickname)
					    let host = process.env.XSL_API
					    that.zljtLogin('sl', id, roleCodes, templateCode).then((rs)=>{
					      if(rs.data.code==0){
					        let slParams = `qstId=${jumpObj.qstId}&token=${rs.data.data.access_token}&nickname=${name}`
					        let src = `${host}?${slParams}`
					        that.iframeUrl = src
									window.open(that.iframeUrl, "_blank");
					      }else{
					        that.$messageError(rs.data.msg)
					      }
					    })
					  }
					  getData();
					},
					async zljtLogin(type, id, roleCodes, templateCode){// 中联集团登录
					  let jumpObj = this.getJumpInfo(type,id)
					  // 加密参数
					  let shanStr = `{clientId=${jumpObj.clientId}, encrypted=${jumpObj.encrypted}, identity=${jumpObj.identity}, item=${jumpObj.item}, qstId=${jumpObj.qstId}, roleCode=${roleCodes}, templateCode=${templateCode}, timeStamp=${jumpObj.timestamp}, token=${jumpObj.token}, userType=${jumpObj.userType}, username=${jumpObj.username}}`;
					  let secretKey = this.setSha1(shanStr, '02424D4FD04A007E453DADA28E4EEE37')
					  let params = {
					    clientId: jumpObj.clientId,
					    encrypted: jumpObj.encrypted,
					    identity: jumpObj.identity,
					    item: jumpObj.item,
					    qstId: jumpObj.qstId,
					    roleCode: roleCodes,
					    sign: secretKey,
					    templateCode: templateCode,
					    timeStamp: jumpObj.timestamp,
					    token: jumpObj.token,
					    userId: jumpObj.userId,
					    userType: jumpObj.userType,
					    username: jumpObj.username,
					  }
					  let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`
					  return axios.post(src, params).then(rs=>rs)
					},
					getJumpInfo(sys,id){// 跳转所用参数集合
					  let that = this
					  let productFlag = sessionStorage.getItem("productFlag"); // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务
					  let courseId = that.$route.query.id
					  let classId = that.$route.query.classId
					  let identity = ""
					  /*
					    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
					    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
					    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
					    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
					    2: (单项: 1)、（实训: 2）
					    200: (单项: NONE)、（实训: teamId）
					    001: templateCode
					  */
					  let encrypted = ""
					  if(productFlag == 1 || productFlag == 2){ //单项
					    identity = sys + 'dx'
					    encrypted = `TEACH_${courseId}_${classId}_1_NONE`
					  }else if(productFlag == 3){ //综合
					    identity = sys + 'zh'
					    encrypted = `TEACH_${courseId}_${classId}_2_NONE`
					  }
					  let obj = {
					    token: localStorage.getItem('Authorization'),
					    courseId: courseId,// 课程id
					    classId: classId,// 班级id
					    qstId: id,//试题id
					    schoolId: sessionStorage.getItem("deptId"),// 机构id
					    orgName: sessionStorage.getItem("schoolName"),// 机构名称
					    username: sessionStorage.getItem("userName"),// 账号
					    userId: sessionStorage.getItem('userId'),// 用户id
					    nickname: sessionStorage.getItem("loginName"),// 用户姓名
					    userType: sessionStorage.getItem("userType"),// 用户类型
					    mobile: sessionStorage.getItem("mobile"),// 手机号
					    sex: sessionStorage.getItem("sex"),// 性别
					    headImgUrl: "",// 头像
					    idCard: "",// 身份证
					    password: 'e10adc3949ba59abbe56e057f20f883e',
					    // item: ${questionDto.questionCode},
					    item: '27011201-6fe9-46b4-ba7f-fe241aed2132',// questionCode
					    identity: identity,
					    encrypted: encrypted,
					    clientId: '1349883712819109890',
					    timestamp: new Date().getTime(),
					  }
					  return obj
					},
        }
    }
</script>

<style lang="scss" scoped>
  .operation_question {
    max-width: 100%;
    background: white;
    height: 100%;
    overflow: auto;
    .question_title{
      margin-left: 30px;
      padding-top:30px;
      span:nth-child(1){
        font-size:18px;
        font-weight: bold;
      }
      span:nth-child(2){
        font-size:12px;
        font-weight: 500;
        margin-left: 12px;
      }
    }
    .title{
      .title_one{
        border-bottom: 1px dashed black;
        width: 95%;
        margin:auto;
      }
      .ql-editor{
        max-width: 95%;
        overflow: auto!important;
        margin:auto;
      }
      /deep/ .ql-editor img{
        max-width: 100% !important;
      }
    }
    .start{
      position: absolute;
      bottom:100px;
      right:38%;
      text-align: center;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/operation.vue